class nostoVariantOOS extends HTMLElement {
  constructor () {
    super()
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PRODUCT.VARIANT_CHANGED,
      this.displayNostoEvent.bind(this),
    )
  }

  displayNostoEvent (event) {
    if (
      event.detail.product.id !==
      this.getAttribute('data-current-product') * 1
    ) { return }
    const nostoSizeRecommendation = this.querySelector(
      '[data-nosto-variant-oss-el="nostoPlacement"]',
    )
    this.setAttribute(
      'data-current-variant-available',
      event.detail.variant.available,
    )
    if (!event.detail.variant.available) {
      if (nostoSizeRecommendation == null) {
        const nostoDiv = document.createElement('div')
        nostoDiv.classList.add('nosto_element')
        nostoDiv.setAttribute('id', 'alternatives-variant-size-product-pages')
        nostoDiv.setAttribute('data-nosto-variant-oss-el', 'nostoPlacement')
        this.appendChild(nostoDiv)
      }
    }
  }
}
customElements.define('nosto-variant-oos', nostoVariantOOS)
